// src/pages/DirectIncomeBalanceLedger/index.js
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Grid, Typography } from "antd";
import DirectIncomeBalanceLedgerFilters from "./components/DirectIncomeBalanceLedgerFilters";
import DirectIncomeBalanceLedgerTable from "./components/DirectIncomeBalanceLedgerTable";
import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";

const { Title } = Typography;

const DirectIncomeBalanceLedger = () => {
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { filters } = useSelector((state) => state.directIncomeBalanceLedger);

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Direct Income Balance Ledger Report",
    removeAfterPrint: true,
  });

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <Title level={4} style={{ margin: 0 }} className="reportBigTitle" >
              Direct Income Balance Ledger
            </Title>
          }
          extra={
            <Button
              type="primary"
              icon={<PrinterOutlined />}
              onClick={handlePrint}
            >
              { !screens.xs && "Print" }
            </Button>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <DirectIncomeBalanceLedgerFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <DirectIncomeBalanceLedgerTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Direct Income Balance Ledger Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <DirectIncomeBalanceLedgerTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default DirectIncomeBalanceLedger;
